export default __webpack_public_path__ + "kz.8b77b6ae.svg";